import React from 'react';
import LegalLayout, { COMPANY } from './LegalLayout';

const Cookie = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="29 May 2026">
    <p data-testid="cookie-intro">
      A cookie is a small text file placed on your device. {COMPANY.shortName} uses cookies and
      similar technologies to keep you signed in, remember preferences, deliver transactional
      services and understand product usage.
    </p>

    <h2>Categories of Cookies We Use</h2>
    <h3>Strictly Necessary</h3>
    <p>Authentication, session, fraud-prevention, security. Without these the Platform will not function.</p>
    <h3>Functional</h3>
    <p>Country, currency, language, recent searches, theme preference. Stored in <code>localStorage</code>.</p>
    <h3>Analytics</h3>
    <p>Anonymised page-views and product events via privacy-friendly analytics partners (e.g. PostHog).
      You may opt out by sending email to {COMPANY.email} with the subject "Opt out of analytics".</p>
    <h3>Advertising</h3>
    <p>We currently do not run third-party ad cookies on the Platform.</p>

    <h2>Managing Cookies</h2>
    <p>You can disable cookies in your browser settings. Disabling strictly-necessary cookies will
      stop you from signing in or completing a booking.</p>

    <h2>Contact</h2>
    <p>{COMPANY.email}</p>
  </LegalLayout>
);

export default Cookie;
